import "../dashboard-sections.css";

const DUMMY = {
  nds_cheek:       100,
  nds_strip:        80,
  broker_strips_n: 120,
  broker_cheeks_n: 100,
  broker_pasting_kg: 300,
};

const BrokeringDay = ({ data = DUMMY, isLoading = false }) => {
  const total = Object.values(data).reduce((s, v) => s + v, 0);

  const boxes = [
    { key: "nds_cheek",       label: "2NDS CHEEK "       },
    { key: "nds_strip",       label: "2NDS STRIP"       },
    { key: "broker_strips_n", label: "BROKER STRIPS (KG)" },
    { key: "broker_cheeks_n", label: "BROKER CHEEKS (KG)" },
    { key: "broker_pasting_kg", label: "BROKER Pasting (KG)" },
  ];

  return (
    <div className="cmn_card pp-brokering-card">
      <div className="pp-brokering-header">
        <div className="pp-shift-title-row">
          <span className="pp-shift-icon">💎</span>
          <span className="pp-shift-title">BROKERING (DAY)</span>
        </div>
        <div className="pp-brokering-total">
          TOTAL BROKERING: <span className="pp-brokering-total-val">{total?.toLocaleString()}</span>
        </div>
      </div>
      <div className="pp-brokering-grid">
        {boxes.map((b) => (
          <div key={b.key} className="pp-brokering-box">
            <div className="pp-brokering-box-label">{b.label}</div>
            <div className="pp-brokering-box-value">
              {isLoading
                ? <span className="db-shimmer" style={{ height: 28, width: 60, display: "block" }} />
                : data[b.key]?.toLocaleString()
              }
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrokeringDay;
